import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { PenLine, ArrowRight } from 'lucide-react';

export default function JourneyPage() {
  var navigate = useNavigate();

  var steps = [
    {
      num: '01',
      title: 'You share',
      body: 'Tell your story in your own words. A challenge, a breakthrough, a dream. It takes less than 2 minutes.',
      color: 'bg-[#07743F]',
      textColor: 'text-white',
    },
    {
      num: '02',
      title: 'We listen',
      body: 'Our team reads every story. We check for safety and truth — not grammar, not perfection.',
      color: 'bg-[#E4E517]',
      textColor: 'text-[#07743F]',
    },
    {
      num: '03',
      title: 'Your story goes live',
      body: 'Approved stories appear on the platform where thousands of people can discover them.',
      color: 'bg-[#72BF44]',
      textColor: 'text-white',
    },
    {
      num: '04',
      title: 'We amplify',
      body: 'Your voice reaches radio stations, WhatsApp groups, community screenings, and policy briefings.',
      color: 'bg-[#07743F]',
      textColor: 'text-white',
    },
    {
      num: '05',
      title: 'Change happens',
      body: 'Decision-makers hear real voices. Investment follows. Policy shifts. Your story becomes evidence.',
      color: 'bg-[#E4E517]',
      textColor: 'text-[#07743F]',
    },
  ];

  return (
    <div className="min-h-screen" style={{ backgroundColor: '#F9F8F6' }}>
      {/* Hero */}
      <section className="py-20 md:py-28 bg-[#07743F] relative overflow-hidden">
        <div className="absolute inset-0">
          <img src="/images/journey-ducks.jpg" alt="" className="w-full h-full object-cover opacity-20" aria-hidden="true" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#07743F]/80 via-[#07743F]/70 to-[#07743F]/90" />
        </div>
        <div className="container mx-auto px-4 relative z-10 text-center">
          <p className="text-xs tracking-[0.25em] uppercase font-bold text-[#E4E517] mb-4">The journey</p>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-serif text-white leading-tight max-w-3xl mx-auto" data-testid="journey-title">
            From your voice to{' '}
            <span className="italic">real change</span>
          </h1>
          <p className="text-lg text-white/70 mt-6 max-w-xl mx-auto">
            This is how a single story becomes policy, investment, and opportunity.
          </p>
        </div>
      </section>

      {/* Steps */}
      <section className="py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-2xl mx-auto space-y-8">
            {steps.map(function(step, idx) {
              return (
                <div key={step.num} className="flex gap-6 animate-discover" style={{ animationDelay: idx * 0.1 + 's' }} data-testid={'journey-step-' + step.num}>
                  <div className={'w-14 h-14 rounded-2xl flex items-center justify-center flex-shrink-0 font-bold text-sm ' + step.color + ' ' + step.textColor}>
                    {step.num}
                  </div>
                  <div className="pt-1">
                    <h3 className="text-xl font-serif text-gray-900 mb-2">{step.title}</h3>
                    <p className="text-gray-500 leading-relaxed">{step.body}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl sm:text-4xl font-serif text-gray-900 mb-4">Ready?</h2>
          <p className="text-gray-500 mb-8 max-w-md mx-auto">
            Your story could be the one that changes everything.
          </p>
          <Button
            onClick={function() { navigate('/submit'); }}
            className="cta-alive bg-[#07743F] hover:bg-[#065a32] text-white rounded-full px-10 py-7 text-lg font-medium"
            data-testid="journey-cta"
          >
            <PenLine className="w-5 h-5 mr-2" />
            Tell Your Story
          </Button>
          <p className="text-sm text-gray-400 mt-4">No account needed. Takes less than 2 minutes.</p>
        </div>
      </section>
    </div>
  );
}
